import * as React from "react"
import * as styles from "./style.module.scss"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Scrollbar } from "swiper"
import { Autoplay, Swiper as RealSwiper } from "swiper"

import IconContactUs from "../IconContactUs/index"

import Heading from '../../images/akasaka/outline/heading.svg'

RealSwiper.use([Autoplay])

// data


type Props = {
  isDesktop: boolean,
  data: {
    heading: string,
    text: string
  }[],
  link: {
    text: string,
    url: string
  },
  slide: string[],
  mapUrl: string
}

// markup
const Outline = (props: Props) => {
  const [isHover, setIsHover] = React.useState(false);

  return (
    <div className={styles.outline}>
      <div className={styles.heading}>
        <img src={Heading} alt="Outline" />
        <span>物件概要</span>
      </div>
      <div className={styles.body}>
        <div className={styles.items}>
          {props.data.map(item => (
            <div className={styles.item}>
              <div className={styles.itemHeading}>{ item.heading }</div>
              <div className={styles.itemText}>{ item.text }</div>
            </div>
          ))}
        </div>
        <div className={styles.contact}>
          <div className={styles.contactText}>詳しい内容はお問合せください</div>
          <a
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            href={props.link.url}
            target="_blank"
            className={styles.button}
          >
            <IconContactUs width={48} height={40} color={props.isDesktop ? isHover ? '#6D7873' : '#fff' : '#fff'} />
            <span>{props.link.text}</span>
          </a>
        </div>
      </div>
      <div className={styles.map}>
        <iframe src={props.mapUrl} width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div className={styles.slide}>
        <Swiper
          spaceBetween={0}
          slidesPerView={"auto"}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 4000
          }}
          scrollbar={{
            hide: true,
          }}
          modules={[Scrollbar]}
        >
          {props.slide.map(item => (
            <SwiperSlide className={styles.slideItem}><img src={item} alt="" /></SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default Outline
